(function(app, $) {
    var $cache = {};

    function initializeCache() {
        $cache.document = $(document);
        $cache.body = $('body');
        $cache.window = $(window);
        $cache.backToTop = $cache.body.find('a.backtotop');
        $cache.basketLink = $cache.body.find('div#header div#logo-basket-container');
        $cache.miniBasketContainer = $cache.body.find('div#header div#logo-basket-container').find('div#minibasket-container');
        $cache.slideshows = $cache.body.find('div.slideshow');
        $cache.navigationLink = $cache.body.find('a.mobile-menu-trigger');
    }

    function initializeDevice() {
        app.device = app.device || {};
        app.device.isTablet = $cache.window.width() >= 768 && $cache.window.width() <= 1024;
        app.device.isMobile = $cache.window.width() < 768;

        // Reload device object
        $cache.window.on('resize', function() {
            app.device.isTablet = $cache.window.width() >= 768 && $cache.window.width() <= 1024;
            app.device.isMobile = $cache.window.width() < 768;
        });
    }

    function initializeEvents() {
        /**
         * CSRF Token security
         */
        jQuery.ajaxSetup({
            headers : {
                'X-CSRF-TOKEN' : $('meta[name="csrf-token"]').attr('content')
            }
        });

        /**
         * Placeholder initialization
         */
        $('input, textarea').placeholder();

        /**
         * Back to top
         */
        $cache.backToTop.on('click', function(e) {
            e.preventDefault();

            app.util.scrollBrowser(0, app.preferences.scrollUpTiming);
        });

        /**
         * Mobile navigation
         */
        $cache.navigationLink.on('click', function(e) {
            e.preventDefault();

            var $self = $(this);
            $self.find('span').toggleClass('open');
            $self.siblings('div.mobile-main-navigation').slideToggle(app.preferences.mobileNavigationToggleTiming);
        });

        /**
         * Hover basket logo
         */
        $cache.basketLink.on('mouseenter', function() {
            if(!$cache.miniBasketContainer.hasClass('empty')) {
                $cache.miniBasketContainer.slideDown(300);
            }
        });
        $cache.basketLink.on('mouseleave', function() {
            if(!$cache.miniBasketContainer.hasClass('empty')) {
                $cache.miniBasketContainer.slideUp(300);
            }
        });

        $cache.document.find('img[data-original]').lazyload();
    }

    function initializeCarousel() {
        $cache.slideshows.each(function() {
            var $slideshow = $(this);
            var $carousel = $slideshow.find('div.jcarousel');
            var autoscroll = typeof $carousel.data('autoscroll') !== 'undefined' ? $carousel.data('autoscroll') : app.preferences.jcarousel.defaultautoscroll;
            var showpagination = typeof $carousel.data('showpagination') !== 'undefined' ? $carousel.data('showpagination') : app.preferences.jcarousel.defaultshowpagination;
            var showarrows = typeof $carousel.data('showarrows') !== 'undefined' ? $carousel.data('showarrows') : app.preferences.jcarousel.defaultshowarrows;
            var fullwidth = typeof $carousel.data('fullwidth') !== 'undefined' ? $carousel.data('fullwidth') : app.preferences.jcarousel.defaultfullwidth;
            var itemsdisplayed = typeof $carousel.data('itemsdisplayeddesktop') !== 'undefined' ? parseInt($carousel.data('itemsdisplayeddesktop'), 10) : app.preferences.jcarousel.defaultitemsdisplayeddesktop;
            if(app.device.isTablet) {
                itemsdisplayed = typeof $carousel.data('itemsdisplayedtablet') !== 'undefined' ? parseInt($carousel.data('itemsdisplayedtablet'), 10) : app.preferences.jcarousel.defaultitemsdisplayedtablet;
            }
            else if(app.device.isMobile) {
                itemsdisplayed = typeof $carousel.data('itemsdisplayedmobile') !== 'undefined' ? parseInt($carousel.data('itemsdisplayedmobile'), 10) : app.preferences.jcarousel.defaultitemsdisplayedmobile;
            }

            var carousel = $carousel.on('jcarousel:create jcarousel:reload', function() {
                var $self = $(this);
                var $items = $self.jcarousel('items');

                if(fullwidth) {
                    $items.css('width', $self.innerWidth() + 'px');
                }
                else {
                    if(app.device.isTablet) {
                        itemsdisplayed = typeof $carousel.data('itemsdisplayedtablet') !== 'undefined' ? parseInt($carousel.data('itemsdisplayedtablet'), 10) : app.preferences.jcarousel.defaultitemsdisplayedtablet;
                    }
                    else if(app.device.isMobile) {
                        itemsdisplayed = typeof $carousel.data('itemsdisplayedmobile') !== 'undefined' ? parseInt($carousel.data('itemsdisplayedmobile'), 10) : app.preferences.jcarousel.defaultitemsdisplayedmobile;
                    }
                    else {
                        itemsdisplayed = typeof $carousel.data('itemsdisplayeddesktop') !== 'undefined' ? parseInt($carousel.data('itemsdisplayeddesktop'), 10) : app.preferences.jcarousel.defaultitemsdisplayeddesktop;
                    }

                    $items.css('width', ($self.innerWidth() / itemsdisplayed) + 'px');
                }
            }).jcarousel({
                animation : {
                    duration : $carousel.attr('data-animationduration') || app.preferences.jcarousel.defaultanimationduration,
                    easing   : $carousel.attr('data-easing') || app.preferences.jcarousel.defaulteasing
                },
                wrap      : $carousel.attr('data-wrap') || app.preferences.jcarousel.defaultwrap
            });

            if(autoscroll) {
                carousel.jcarouselAutoscroll({
                    interval  : $carousel.attr('data-slideduration') || app.preferences.jcarousel.defaultslideduration,
                    target    : '+=1',
                    autostart : true
                });
            }

            if(showpagination) {
                $slideshow.find('.jcarousel-pagination').jcarouselPagination({
                    item     : function(page) {
                        return '<a href="#' + page + '" class="jcarousel-pagination-dot"></a>';
                    },
                    carousel : carousel
                });
            }

            if(showarrows) {
                $slideshow.find('.jcarousel-control.prev').jcarouselControl({
                    target   : '-=1',
                    carousel : carousel
                });

                $slideshow.find('.jcarousel-control.next').jcarouselControl({
                    target   : '+=1',
                    carousel : carousel
                });
            }
        });
    }

    app.components = app.components || {};
    app.components.global = {
        init : function() {
            initializeCache();
            initializeDevice();
            initializeEvents();
            initializeCarousel();
        }
    };
}(window.app = window.app || {}, jQuery));
